export default "__VITE_ASSET__CWqVjTo5__"